import { render, staticRenderFns } from "./OrdenArchivos.vue?vue&type=template&id=8130215e&scoped=true&"
import script from "./OrdenArchivos.vue?vue&type=script&lang=js&"
export * from "./OrdenArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8130215e",
  null
  
)

export default component.exports